import { filtersHelper } from '@/utils';
import { userModel } from '@/models/api/user.model';
import { errorLogModel } from '@/models/api/errorLog.model';
import { activityLogModel } from '@/models/api/activityLog.model';
import { communicationLogModel } from '@/models/api/communicationLog.model';

export const requestLogModel = (data) => ({
    uuid: data?.uuid,
    method: data?.method,
    path: data?.path,
    pathPrefix: data?.path_prefix,
    files: data?.files,
    requestPayload: data?.request_payload,
    responsePayload: data?.response_payload,
    ip: data?.ip,
    url: data?.url,
    scheme: data?.scheme,
    host: data?.host,
    port: data?.port,
    cookies: data?.cookies,
    userAgent: data?.user_agent,
    statusCode: data?.status_code,
    success: data?.success,
    performance: data.performance ? {
        durationMs: data.performance?.duration_ms,
        memoryUsedMb: data.performance?.memory_used_mb,
        memoryPeakMb: data.performance?.memory_peak_mb,
    } : null,
    createdAt: filtersHelper.getDateTimeFormat(data.created_at),
    updatedAt: filtersHelper.getDateTimeFormat(data.updated_at),
    user: data.user ? userModel(data.user) : null,
    errorLog: data.error_log ? errorLogModel(data.error_log) : null,
    activityLog: data.activity_log ? activityLogModel(data.activity_log) : null,
    communicationLog: data.communication_log ? communicationLogModel(data.communication_log) : null,
});